import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (token) {
      login(token);
      navigate('/', { replace: true });
    } else if (error) {
      console.error('Authentication error:', error);
      navigate('/', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [searchParams, login, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className='text-center'>
        <div className='loading-spinner' style={{ margin: '0 auto 1rem' }}></div>
        <p style={{ color: 'white', fontSize: '1.2rem' }}>Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
